export const issuedCurrency = (value: Record<string, string>) => {
  if (value.type === "COM") {
    return {
      data: value.FO166,
    };
  }

  const currentCurrency = value.DS004 ?? null;
  const digitalExposure = value?.DQ702 ?? null;

  if (digitalExposure && digitalExposure === "Cryptocurrency") {
    const securityCurrencyPair = value.DU406 ?? "";
    // Expect format "SECURITY/CURRENCY" (e.g. "XBT/USD")
    const securityCurrency = securityCurrencyPair.split("/")[1];

    if (securityCurrency && securityCurrency !== currentCurrency) {
      return {
        data: securityCurrency,
      };
    }
  }

  return {
    data: value.DS004,
  };
};
